export const AUTH_CONFIG = {
  domain: 'dev-hs34gsbmgy487zbs.us.auth0.com',
  clientId: 'x757TMhD89KPK0zfsfQtycLG8turoeht',
  callbackUrl: process.env.REACT_APP_CALLBACK_URL || 'http://localhost:3000/callback'
}